import useAction from '../utils/useAction';

export const makeActionHandler = (action: any, params: any) => {
	const { onDownloadPdf } = useAction(params);

	switch (action.id) {
		case 'download':
			return () => {
				onDownloadPdf();
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
